import { useCurrentAccountId } from "@zapier/identity";
import { useCurrentUser } from "../user/useCurrentUser";

export function useUserAccountRole() {
  const accountId = useCurrentAccountId();
  const { user } = useCurrentUser();

  const role = user?.roles?.find((role) => role.accountId === accountId)?.role;

  return {
    customuserId: user?.id,
    isAdmin: role === "admin",
    isSuperAdmin: role === "super_admin",
    isAccountOwner: role === "owner",
    isMember: role === "member",
    role,
    roles: user?.roles,
  };
}
